import CryptoJS from 'crypto-js';

export function decryptData2(encryptedData) {
  const C = CryptoJS;
  const Key = C.enc.Utf8.parse('!*@#)($^%1fgv&C=!*@#)($^%1fgv&C=');
  const IV = C.enc.Utf8.parse('gqLOHUioQ0QjhuvI');

  const decryptedText = C.AES.decrypt(encryptedData, Key, {
    keySize: 256 / 32,
    iv: IV,
    mode: C.mode.CBC,
    padding: C.pad.Pkcs7,
  });

  return decryptedText.toString(C.enc.Utf8);
}

export function encryptData2(data) {
  const C = CryptoJS;
  const Key = C.enc.Utf8.parse('!*@#)($^%1fgv&C=!*@#)($^%1fgv&C=');
  const IV = C.enc.Utf8.parse('gqLOHUioQ0QjhuvI');

  const encryptedText = C.AES.encrypt(
    JSON.stringify(data),
    Key,
    {
      keySize: 256 / 32,
      iv: IV,
      mode: C.mode.CBC,
      padding: C.pad.Pkcs7,
    },
  );

  return encryptedText.toString();
}
